<template>
  <div class="mine" v-wechat-title="$route.meta.title">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="head">
        <router-link v-if="!isXqc" class="about_show_button" to="/about">
          <van-icon :name="aboutIcon" />
          <span>关于影子</span>
        </router-link>

        <img v-if="!isXqc" class="head_back" src="@/assets/img/my/组 233@2x.png" alt="" />
        <img v-if="isXqc" class="head_back head_back2" src="@/assets/img/mine/minBac.png" alt="" />
        <div class="personal_card">
          <div class="head_head">
            <div class="dec">
              <p class="name_row">
                <span class="name">{{ NickName }}</span>
              </p>
              <p class="name_row">
                <span>{{ Duties }}</span>
              </p>
              <p class="name_row">影子号：{{ ID }}</p>
              <p class="name_row" style="color: #1e90ff">
                业之峰<span v-if="
                  IsDirect != '' || IsDirect != null || IsDirect != undefined
                ">{{ "-" + IsDirect }}</span><span v-if="Branch != '' || Branch != null || Branch != undefined">{{
                  "/" + Branch }}</span><span v-if="
                    Storefront != '' ||
                    Storefront != null ||
                    Storefront != undefined
                  ">{{ "/" + Storefront }}</span>
              </p>
            </div>

            <div class="avatar_box" :class="{ new_fun: configNewFun == '' }">
              <img class="avatar" v-lazy="{
                src: Avatar,
                error: require('@/assets/img/visitcunt/avt.png'),
                loading: require('@/assets/img/visitcunt/avt.png'),
              }" alt="" @click="goToConfig()" />
            </div>
          </div>

          <div class="data">
            <div class="item" @click="goVisitcunt()">
              <p class="num">{{ visitcunt }}</p>
              <p class="new_cunt" v-if="newVisitcunt > 0">
                {{ newVisitcunt > 99 ? "99+" : newVisitcunt }}
              </p>
              <p class="tit">访客量</p>
            </div>
            <div class="item get_client" @click="goToMyMlient()">
              <p class="num">{{ getclientcount }}</p>
              <i class="new" v-show="!IsLooked"></i>
              <p class="tit">获客</p>
            </div>
            <div class="item get_client" @click="goFc(0)">
              <p class="num">{{ forwardTotal }}</p>
              <!-- <i class="new"></i> -->
              <p class="tit">转发</p>
            </div>
            <div class="item get_client" @click="goFc(1)">
              <p class="num">{{ collectionTotal }}</p>
              <!-- <i class="new"></i> -->
              <p class="tit">收藏</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 活动海报 -->
      <div v-if="isXqc" class="posterBox">
        <div class="posterImgBox" @click="goPoster">
          <img class="posterImg" src="@/assets/img/mine/hdhb.png" alt="">
        </div>
      </div>
      <!-- 专题报名 -->
      <div v-if="isXqc" class="posterBox">
        <div class="posterImgBox" @click="goSignUp">
          <img class="posterImg" src="@/assets/img/mine/h5zt.png" alt="">
        </div>
      </div>
      <!-- 专题报名 -->
      <div v-if="isXqc" class="posterBox posterBox2">
        <div class="posterImgBox" @click="goPosterVideo">
          <img class="posterImg" src="@/assets/img/mine/videoBtn.png" alt="">
        </div>
      </div>
      <!-- 进入小程序 -->
      <van-skeleton v-if="!isXqc" title :row="2" :loading="loading">
        <div class="go-programmin">
          <wx-open-launch-weapp username="gh_1b943db9de6c" :path="'pages/middlePage/middlePage.html'
            ">
            <script type="text/wxtag-template">
              {{wxStyle}}
              <div class="btn"></div>
            </script>
          </wx-open-launch-weapp>
          <img src="@/assets/img/icon/my/icon_banner.png" />
        </div>
      </van-skeleton>
      <!-- 营销拓客 -->
      <van-skeleton v-if="!isXqc" title :row="2" :loading="loading">
        <p class="grounp_tit">营销拓客</p>
        <div class="icon_group">
          <a class="icon_item" :href="url">
            <img src="@/assets/img/icon/my/icon-官网@2x.png" alt="" />
            <span>官网</span>
          </a>

          <router-link class="icon_item" to="/softarticle">
            <img src="@/assets/img/icon/my/icon-文库@2x.png" alt="" />
            <span>营销软文库</span>
          </router-link>

          <router-link class="icon_item" to="/home">
            <img src="@/assets/img/icon/my/icon-专题库@2x.png" alt="" />
            <span>专题库</span>
          </router-link>

          <router-link class="icon_item" :class="{ new_fun: courseNewFun2 == '' }"
            :to="{ path: '/othercard', query: { p: id } }">
            <img src="@/assets/img/icon/my/icon-名片@2x.png" alt="" />
            <span>名片</span>
          </router-link>
          <!-- v-if="id==19100||id==18186||id==19115||id==19603||id==19622||id==14695||id==18924||id==14717||id==19185||city.id==125" -->
          <router-link class="icon_item" to="/forms">
            <img src="@/assets/img/icon/my/icon-表单问卷@2x.png" alt="" />
            <span>表单问卷</span>
          </router-link>
        </div>
      </van-skeleton>
      <!-- 精准锁客 -->
      <van-skeleton v-if="!isXqc" title :row="2" :loading="loading">
        <p class="grounp_tit">精准锁客</p>
        <div class="icon_group">
          <!-- v-if="id==19100||id==18186||id==19115||id==19603||id==19622||id==14695||id==18924||id==14717||city.id==125"> -->
          <!-- v-if="id==19100||id==18186||id==19115||id==19603||id==19622||id==14695||id==18924||id==14717||id==20833" -->
          <router-link class="icon_item" to="/realCase">
            <img src="@/assets/img/icon/my/icon-实景案例库@2x.png" alt="" />
            <span>实景案例库</span>
          </router-link>

          <router-link class="icon_item" to="/panoramas">
            <img src="@/assets/img/icon/my/icon-全景@2x.png" alt="" />
            <span>3D全景</span>
          </router-link>

          <!-- <router-link class="icon_item" to="/videoLibrary" v-if="!( ID == 19603 || ID == 19115 || ID == 14695 || ID ==21741||ID== 19185)">
            <img src="@/assets/img/icon/my/icon-视频库@2x.png" alt="" />
            <span>视频库</span>
          </router-link>

          <router-link class="icon_item" to="/imgLibrary" v-if="!(ID == 19603 || ID == 19115 || ID == 14695 || ID ==21741||ID== 19185)">
            <img src="@/assets/img/icon/my/icon-图片库@2x.png" alt="" />
            <span>图片库</span>
          </router-link>

          <router-link class="icon_item" to="/friends"  v-if="!(ID==21188|| ID == 19603 || ID == 19115 || ID == 14695 || ID ==21741||ID== 19185)">
            <img src="@/assets/img/icon/my/icon-朋友圈@2x(1).png" alt=""  />
            <span>朋友圈</span>
          </router-link> -->

          <router-link class="icon_item" to="/shortVideo">
            <img src="@/assets/img/icon/my/icon-短视频@2x.png" alt="" />
            <span>营销短视频</span>
          </router-link>
          <router-link class="icon_item" to="/materialCenter">
            <img src="@/assets/img/icon/my/icon_sucaiku@2x.png" alt="" />
            <span>素材中心 </span>
          </router-link>
          <router-link class="icon_item" to="/decorationCase">
            <img src="@/assets/img/icon/my/icon_zhuangxiu@2x.png" alt="" />
            <span>装修案例</span>
          </router-link>
          <!-- <div
          v-else
           
            class="icon_item"
            @click="toast"
          >
            <img src="@/assets/img/icon/my/icon_zhuangxiu@2x.png" alt="" />
            <span>装修案例</span>
          </div> -->
        </div>
      </van-skeleton>
      <!-- 转化获客 -->
      <van-skeleton v-if="!isXqc" title :row="2" :loading="loading">
        <p class="grounp_tit">转化获客</p>
        <div class="icon_group" v-if="judgeWechat">
          <!-- 案例分享 -->
          <div class="icon_item">
            <img src="@/assets/img/icon/my/icon-案例分享@2x.png" alt="" />
            <span>热装小区</span>

            <wx-open-launch-weapp username="gh_1b943db9de6c" :path="'pages/xiaoquanli/xiaoquanli.html?userId=' +
              id +
              '&branchid=' +
              city.id
              ">
              <script type="text/wxtag-template">
                {{wxStyle}}
                <div class="btn"></div>
              </script>
            </wx-open-launch-weapp>
          </div>

          <!-- 案例打包 -->
          <div class="icon_item" @click="goCasePkgs">
            <img src="@/assets/img/icon/my/icon-案例打包@2x.png" alt="" />
            <span>案例打包</span>
          </div>

          <!-- 免费报价 -->
          <div class="icon_item">
            <img src="@/assets/img/icon/my/icon-免费报价@2x.png" alt="" />
            <span>免费报价</span>

            <wx-open-launch-weapp username="gh_1b943db9de6c" :path="'pages/baojia/baojia.html?userId=' + id + '&area=' + city.name
              ">
              <script type="text/wxtag-template">
                {{wxStyle}}
                <div class="btn"></div>
              </script>
            </wx-open-launch-weapp>
          </div>
          <!-- 免费设计 -->
          <div class="icon_item">
            <img src="@/assets/img/icon/my/icon-免费设计@2x.png" alt="" />
            <span>免费设计</span>

            <wx-open-launch-weapp username="gh_1b943db9de6c" :path="'pages/yuyue/yuyue.html?userId=' + id + '&area=' + city.name
              ">
              <script type="text/wxtag-template">
                {{wxStyle}}
                <div class="btn"></div>
              </script>
            </wx-open-launch-weapp>
          </div>
          <!-- 免费量房 -->
          <div class="icon_item">
            <img src="@/assets/img/icon/my/icon-免费量房@2x.png" alt="" />
            <span>免费量房</span>

            <wx-open-launch-weapp username="gh_1b943db9de6c"
              :path="'pages/room/room.html?userId=' + id + '&area=' + city.name">
              <script type="text/wxtag-template">
                {{wxStyle}}
                <div class="btn"></div>
              </script>
            </wx-open-launch-weapp>
          </div>

          <div class="icon_item" @click="goDesigner">
            <img src="@/assets/img/icon/my/icon-设计师@2x.png" alt="" />
            <span>本地设计师</span>
          </div>
          <router-link class="icon_item" to="/H5">
            <img src="@/assets/img/icon/my/icon_anli@2x.png" alt="" />
            <span>H5专区</span>
          </router-link>
        </div>

        <div class="icon_group" v-else>
          <router-link class="icon_item" :to="{
            path: '/miniprogram',
            query: {
              page: 'pages/xiaoquanli/xiaoquanli',
              userId: id,
              branchid: city.id,
            },
          }">
            <img src="@/assets/img/icon/my/icon-案例分享@2x.png" alt="" />
            <span>热装小区</span>
          </router-link>

          <router-link class="icon_item" :to="{ path: '/casepkgs' }">
            <img src="@/assets/img/icon/my/icon-案例打包@2x.png" alt="" />
            <span>案例打包</span>
          </router-link>

          <router-link class="icon_item" :to="{
            path: '/miniprogram',
            query: { page: 'pages/baojia/baojia', userId: id },
          }">
            <img src="@/assets/img/icon/my/icon-免费报价@2x.png" alt="" />
            <span>免费报价</span>
          </router-link>

          <router-link class="icon_item" :to="{
            path: '/miniprogram',
            query: { page: 'pages/yuyue/yuyue', userId: id },
          }">
            <img src="@/assets/img/icon/my/icon-免费设计@2x.png" alt="" />
            <span>免费设计</span>
          </router-link>

          <router-link class="icon_item" :to="{
            path: '/miniprogram',
            query: { page: 'pages/room/room', userId: id },
          }">
            <img src="@/assets/img/icon/my/icon-免费量房@2x.png" alt="" />
            <span>免费量房</span>
          </router-link>

          <router-link class="icon_item" to="/designers">
            <img src="@/assets/img/icon/my/icon-设计师@2x.png" alt="" />
            <span>本地设计师</span>
          </router-link>
          <router-link class="icon_item" to="/H5">
            <img src="@/assets/img/icon/my/icon_anli@2x.png" alt="" />
            <span>H5专区</span>
          </router-link>
        </div>
      </van-skeleton>
    </van-pull-refresh>

    <LaunchPoster />

    <wxsdk :isHidden="true" :config="wxconfig"></wxsdk>
  </div>
</template>

<script>
// @ is an alias to /src

import { mapState, mapMutations } from "vuex"; //先要引入
// import $ from 'jquery'
import { Toast } from "vant";
// import moment from 'moment';

import { aboutCompany, judgeWechat } from "@/util/util";
import mixins from "@/util/mixins";

import { GetUserSimpleDetails, GetUserInfo } from "@/api/user";
import {
  GetVisitTotal,
  GetClientTotal,
  GetForwardTotal,
  GetCollectionTotal,
  GetUserType,
} from "@/api/mine";
import Detail from "../imgLibrary/detail.vue";

export default {
  name: "mine",
  mixins: [mixins],
  data() {
    return {
      isXqc: false,
      aboutIcon: require("@/assets/img/icon/my/icon-关于影子@2x.png"),
      wxconfig: {
        title: "业之峰环保装饰", // 分享标题
        link: window.location.href.split("#")[0], // 分享链接
        desc: "诺云出品，营销神器", // 分享描述
        imgUrl:
          "https://yenova-picfw.oss-cn-qingdao.aliyuncs.com/shadow/20200215084744", // 分享图标
      },
      NickName: "",
      Duties: "",
      ID: "",
      IsDirect: "",
      Branch: "",
      Storefront: "",
      Avatar: "",
      visitcunt: 0, //访客量
      newVisitcunt: 0, //新增访客量
      getclientcount: 0,
      IsLooked: false,
      url: "",
      city: {},
      judgeWechat: judgeWechat(),
      shardIcon: require("@/assets/img/icon/my/icon-案例分享@2x.png"),
      casePkgIcon: require("@/assets/img/icon/my/icon-案例打包@2x.png"),
      baojiaIcon: require("@/assets/img/icon/my/icon-免费报价@2x.png"),
      shejiIcon: require("@/assets/img/icon/my/icon-免费设计@2x.png"),
      roomIcon: require("@/assets/img/icon/my/icon-免费量房@2x.png"),
      wxStyle:
        "<style>" +
        ".btn{" +
        "width: 100%;" +
        "height: 100px;" +
        "}" +
        "</style>",
      isLoading: false,
      isFirst: true, // 是否第一次启动
      loading: true,
    };
  },
  computed: {
    ...mapState([
      "forwardTotal",
      "collectionTotal",
      "id",
      "avatar",
      "branchid",
      "configNewFun",
      "courseNewFun2",
    ]),
  },
  components: {
    wxsdk: () => import("@/components/Wxsdk.vue"),
    LaunchPoster: () => import("./components/LaunchPoster"),
  },
  watch: {
    $route(to, from) {
      if(this.isXqc){
        this.$store.commit('changeNav', false)
      }else{
        // console.log(to, from,100);
        // this.$store.commit('changeNav', true)
      }
    }
  },
  created() {
    // if(this.isXqc){
    //     this.$store.commit('changeNav', false)
    //   }else{
    //     this.$store.commit('changeNav', true)
    //   }
    this.city = aboutCompany.getById(parseInt(this.branchid));
    console.log(this.city);
    console.log("branch", this.branchid);
    if (this.city && this.city.domain) {
      this.url =
        "https://m.yzf.com.cn/" +
        this.city.domain +
        "?from=shadow&p=" +
        this.id +
        "&avt=" +
        this.avatar +
        "&url=https://yz.yzf.com.cn/mine";
      console.log('url: ', this.url)
    }
    // console.log('created')
  },
  mounted() {
    this.DataInit();
  },
  // 页面激活时
  activated() {

  },
  methods: {
    ...mapMutations([
      "loadingShow",
      "setForwardTotal",
      "setCollectionTotal",
      "setStorefrontName",
      "setAvatar",
      "signOut",
    ]),
    async GetUserType(){
      const res = await GetUserType({
        id:this.id
      })
      console.log(res.data.type,'是否主持人');
      if(res.data.type==1){
        this.isXqc = true
        this.$store.commit('changeNav', false)
      }else{
        this.isXqc = false
        this.$store.commit('changeNav', true)
      }
      
    },
    goPoster() {
      this.$router.push(`/posterList?p=${this.id}`)
    },
    goPosterVideo() {
      this.$router.push(`/posterVideoList?p=${this.id}`)
    },
    goSignUp() {
      this.$router.push({
        name: "subjectdetails",
        query: {
          p: this.id,//推广员id
          id: 16759,
          xqc: '1',
          from: 'shadow'
        }
      });
    },
    toast() {
      Toast.success({
        message: '上传影子案例对接官网中。'
      })
    },
    async onRefresh() {
      this.isFirst = true;

      await this.DataInit();

      this.isLoading = false;

      Toast.success({
        message: "刷新成功",
      });
    },
    async DataInit() {
      // console.log('DataInit')
      this.loading = true;
      if (this.isFirst) {
        this.loadingShow("show");
        this.isFirst = false;
      }

      await this.getUser(); //获取用户基本信息
      await this.getTotal(); //获取转发和收藏总数
      await this.GetDisplayCount(); //获取本月获客数、展现量
      this.loadingShow("hide");
      this.loading = false;
    },
    goMyCard() {
      // this.$router.push('/mycard')
      this.$router.push({
        name: "othercard",
        query: {
          p: this.id,
        },
      });
    },
    goCasePkgs() {
      this.$router.push({
        path: "/casepkgs",
      });
    },
    goDesigner() {
      this.$router.push({
        path: "/designers",
      });
    },
    async GetDisplayCount() {
      //获取访客量
      await GetVisitTotal().then((res) => {
        // console.log(res)
        if (res.Success) {
          this.visitcunt = res.Object.Total;
          this.newVisitcunt = res.Object.NewCount;
        }
      });

      //获取获客总数
      await GetClientTotal().then((res) => {
        if (res.Success) {
          // console.log(res)
          this.getclientcount = res.Object.Total;
          this.IsLooked = res.Object.IsLooked;
        }
      });
    },
    //获取用户信息
    async getUser() {
      await GetUserSimpleDetails(this.id).then((res) => {
        if (res.Success) {
          var data = res.Object;

          this.Duties =
            data.duties == null || data.duties == "" ? "家装顾问" : data.duties;
        }
      });

      await GetUserInfo()
        .then((res) => {
          this.NickName = res.Object.NickName; //姓名
          this.ID = res.Object.ID; //推广员id
          this.IsDirect = res.Object.IsDirect; //直营/非直营
          this.Branch = res.Object.Branch; //城市
          this.Storefront = res.Object.Storefront; //员工所在部门
          this.Avatar = res.Object.Avatar; //头像
          this.GetUserType()
          this.setStorefrontName(res.Object.Storefront); //存入部门名称
          this.setAvatar(res.Object.Avatar); //存入微信头像
          // console.log(res)
        })
        .catch(() => {
          this.signOut();

          // alert('退出登录')
          // this.$router.push("/login");
          setTimeout(() => {
            window.location.href = "https://yz.yzf.com.cn";
          }, 2000);
        });
    },
    //获取转发和收藏的总数
    async getTotal() {
      await GetForwardTotal().then((res) => {
        if (res.Success) {
          // console.log(res)
          this.setForwardTotal(res.Object.Total); //存入转发的总数
          // console.log(res.Object.Total)
        }
      });

      await GetCollectionTotal().then((res) => {
        if (res.Success) {
          this.setCollectionTotal(res.Object.Total);
        }
      });
    },
    goFc(tab) {
      // console.log(tab)
      this.$router.push({
        name: "fc",
        query: {
          active: tab,
        },
      });
    },
    goToConfig() {
      this.$router.push("/config");
    },
    goToMyMlient() {
      this.$router.push("/myclient");
    },
    goVisitcunt() {
      this.$router.push("/visitcunt");
    },
  },
};
</script>

<style lang="scss" scoped>
.mine {
  background: #ffffff;
  min-height: calc(100vh - 100px);
  padding-bottom: 100px;

  .head {
    position: relative;
    display: flex;
    flex-direction: column;

    .about_show_button {
      position: absolute;
      top: 24px;
      right: 24px;
      z-index: 10;
      width: 170px;
      height: 48px;
      background: #ffffff;
      color: #1e90ff;
      border-radius: 34px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      font-weight: 600;

      i {
        // width: 32px;
        // height: 32px;
        // img{
        // margin: 0;

        // }
        margin-right: 6px;
      }

      &.new_fun {
        &::after {
          top: 5px;
          right: 0px;
          z-index: 3;
        }
      }
    }
    .head_back2{
      object-fit: cover;
    }
    .head_back {
      width: 750px;
      height: 544px;
      z-index: 1;
    }

    .personal_card {
      width: 702px;
      height: 342px;
      background: #ffffff;
      border-radius: 20px;
      margin: 0 auto;
      margin-top: -342px;
      z-index: 10;
      box-shadow: 2px 0px 8px rgba(46, 46, 46, 0.2);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 48px;
      position: relative;

      .head_head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .avatar_box {
          // width: calc( 164px + 50px );
          margin: 40px 40px 0 0;
          position: relative;

          &::before {
            content: "设置";
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            color: #ffffff;
            background: #1e90ff;
            width: 60px;
            height: 32px;
            font-size: 20px;
            border-radius: 16px;
            position: absolute;
            bottom: -5px;
            left: calc(50% - 60px / 2);
          }

          .avatar {
            width: 140px;
            height: 140px;
            border-radius: 50%;
            z-index: 20;
          }

          &.new_fun {
            &::after {
              top: 0px;
              right: 0px;
              z-index: 10;
            }
          }
        }

        .dec {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          text-align: left;
          margin-top: 40px;
          margin-left: 40px;

          p {
            font-size: 24px;
            color: #8b8b8b;

            &.name_row {
              font-size: 24px;
              // margin-bottom: 20px;

              .name {
                font-size: 36px;
                color: #191919;
                margin-right: 24px;
                font-weight: 600;
              }
            }
          }
        }
      }

      .data {
        display: flex;
        flex-direction: row;

        margin-bottom: 32px;

        .item {
          flex: 1;

          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;

          .tit {
            font-size: 24px;
            color: #8b8b8b;
          }

          .num {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 56px;
            font-size: 40px;
            color: #1e90ff;
            font-weight: 600;
            margin-bottom: 8px;
            border-right: 1px solid #dddddd;
          }

          &:last-child {
            .num {
              border-right: 0;
            }
          }

          .new_cunt {
            position: absolute;
            top: -20px;
            left: 120px;
            background: #ff3c2e;
            border-radius: 25px;
            box-shadow: 0 0 10px 2px #febdb9;
            color: #ffffff;
            padding: 0 5px;
            min-width: 25px;
            min-height: 35px;
            font-size: 16px;
            text-align: center;
            line-height: 35px;
          }

          &.get_client {
            position: relative;

            .new {
              position: absolute;
              top: -12px;
              right: 30px;
              width: 28px;
              height: 28px;
              background: #ff3c2e;
              border-radius: 50%;
              box-shadow: 0 0 10px 2px #febdb9;
              transform: scale(0.5);
              transform-origin: 0% center;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }

  .posterBox {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    .posterImg {
      width: 700px;
      // height: 122px;
    }
  }
.posterBox2{
margin-bottom: 300px;
}
  .go-programmin {
    width: 702px;

    margin: 0 auto;
    margin-bottom: 37.5px;
    position: relative;

    wx-open-launch-weapp {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
      z-index: 2;
      opacity: 0;
    }

    img {
      width: 100%;
    }
  }

  .grounp_tit {
    font-size: 32px;
    font-weight: 600;
    color: #191919;
    margin-left: 48px;
    margin-bottom: 20px;
  }

  .icon_group {
    // display: grid;
    // grid-template-columns: 1fr 1fr 1fr 1fr; /* 相当于 1fr 1fr 1fr */
    // grid-template-rows: 1fr; /* fr单位可以将容器分为几等份 */
    // grid-gap: 0; /* grid-column-gap 和 grid-row-gap的简写 */
    // grid-auto-flow: row;
    width: 100vw;
    margin-bottom: 12px;
    overflow: hidden;

    .icon_item {
      width: 25vw;
      float: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 36px;
      position: relative;
      z-index: 1;

      wx-open-launch-weapp {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        z-index: 2;
        opacity: 0;
      }

      &.new_fun {
        &::after {
          top: 0px;
          right: 30px;
          z-index: 3;
        }
      }

      img {
        width: 88px;
        height: 92px;
        margin-bottom: 4px;
      }

      span {
        font-size: 24px;
        color: #8b8b8b;
      }
    }
  }
}
</style>